import { render, staticRenderFns } from "./BaseSalePricePopup.vue?vue&type=template&id=48865f15"
import script from "./BaseSalePricePopup.vue?vue&type=script&lang=js"
export * from "./BaseSalePricePopup.vue?vue&type=script&lang=js"
import style0 from "./BaseSalePricePopup.vue?vue&type=style&index=0&id=48865f15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports